import React from "react";
import { connect } from "react-redux";
import { putData } from "Source/globalFunction";

@connect(store => {
    return {};
})

class DiscardChanges extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div class="modal fade confirm-modal bg-overlay" id={`${this.props.id?this.props.id: 'discardChanges'}`}>
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header border-none pd20 pdl40 pdr40">
                            <div class="row">
                                <div class="col-lg-10 col-md-10 col-sm-10">
                                    <p class="text-size18 text-blue brndnTxt-m mb0 mt5">Discard Changes?</p>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2">
                                    <a class="text-right text-black" data-dismiss="modal" aria-label="Close">
                                        <i class="material-icons text-black text-size22">close</i>
                                    </a>
                                </div>
                            </div>    
                        </div>
                        <div class="modal-body bt pt20 pb20">
                            <p class="text-black m0">
                                Do you wish to proceed?               
                            </p>
                        </div>
                        <div class="modal-footer pt15 pb15">
                            <div class="row">

                                <div class="col-lg-4 col-md-4 col-sm-4">
                                    <button type="button" class="btn btn-cancel text-black m0" data-dismiss="modal">Cancel</button>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8 text-align-right">
                                    <button type="button" class="btn btn-blue m0" style={{ padding: "9px 20px"}} onClick={this.props.onCancel}>Discard</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DiscardChanges;
